import { render, staticRenderFns } from "./veStuStipendType.vue?vue&type=template&id=3d612c60&scoped=true"
import script from "./veStuStipendType.vue?vue&type=script&lang=js"
export * from "./veStuStipendType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d612c60",
  null
  
)

export default component.exports